import type { ReactNode } from 'react';

export const symbol_tv_remote: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M340-100h280v-237q-27 26-62.5 41.5T480-280q-42 0-77.5-15.5T340-337v237Zm239-280.76q41-40.77 41-99Q620-538 579.24-579q-40.77-41-99-41Q422-620 381-579.24q-41 40.77-41 99Q340-422 380.76-381q40.77 41 99 41Q538-340 579-380.76ZM340-623q27-26 62.5-41.5T480-680q42 0 77.5 15.5T620-623v-237H340v237Zm0 583q-24 0-42-18t-18-42v-760q0-24 18-42t42-18h280q24 0 42 18t18 42v760q0 24-18 42t-42 18H340Zm101-401.06q-16-16.06-16-39T441.06-519q16.06-16 39-16T519-518.94q16 16.06 16 39T518.94-441q-16.06 16-39 16T441-441.06Zm60.5-297.62q8.5-8.67 8.5-21.5 0-12.82-8.68-21.32-8.67-8.5-21.5-8.5-12.82 0-21.32 8.68-8.5 8.67-8.5 21.5 0 12.82 8.68 21.32 8.67 8.5 21.5 8.5 12.82 0 21.32-8.68ZM480-280Zm0-400Z"
		/>
	</svg>
);
